import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MFA_CONFIG } from '../tokens/mfa.token';
import { MFARedirectEffects } from './store/effects/mfa-redirect-effects';
import { MFAEffects } from './store/effects/mfa.effects';
import { MFARedirectUrlKeys, MFARedirectUrlMap } from './types';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([MFAEffects, MFARedirectEffects]),
    StoreModule,
  ],
})
export class MfaModule {
  static forRoot(config: MFARedirectUrlMap): ModuleWithProviders<MfaModule> {
    return {
      ngModule: MfaModule,
      providers: [
        {
          provide: MFA_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}

export function generateMFAModuleConfig(
  config: Partial<MFARedirectUrlMap>,
): MFARedirectUrlMap {
  const finalMap: MFARedirectUrlMap = {
    [MFARedirectUrlKeys.ShoppingCart]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.CashbackOneTimeRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.PointsTransferOneTimeRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.EverydaySpendOneTimeRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.PointsTransferAutoRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.EverydaySpendAutoRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.CashBackAutoRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.PhysicalGiftCardAutoRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.DigitalGiftCardAutoRedemption]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
    [MFARedirectUrlKeys.AutoRedemptionUpdate]: {
      ghRedirectUrl: null,
      rdRedirectUrl: null,
    },
  };
  for (const key of Object.keys(config)) {
    if (config[key as MFARedirectUrlKeys] !== null) {
      // @ts-ignore
      finalMap[key as MFARedirectUrlKeys] = config[key as MFARedirectUrlKeys];
    }
  }
  return finalMap;
}
